// extracted by mini-css-extract-plugin
export default {"videoWrapper":"_4aAchINrEP54iZY6kNscYK","videoContainer":"_2NABx6LRqGXmBQgsrBosM6"};